import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class BacsModel extends BaseModel {
  date = null;


  static TRANSLATABLE_FIELDS = [];

  rules = {};

  attributeLabels = {
    date: i18n.t('Value Date'),
  };

  attributeHints = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(BacsModel);
